module.exports = __webpack_public_path__ + "static/media/DogsRule.d3edf871.ico";